module.exports = __webpack_public_path__ + "img/smart-scan-1.019a3469.png";